var map = {
	"./logos/DISC-BLACK.png": [
		9310,
		310
	],
	"./logos/DISC.png": [
		1744
	],
	"./logos/LOGO-imagine.svg": [
		6951,
		951
	],
	"./logos/LogoViVi_Fondos claros.png": [
		5570
	],
	"./logos/OASIS-LOGO_imagotipo-gradient-white.svg": [
		1223,
		223
	],
	"./logos/OASIS-LOGO_isologo-gradient-white-07.svg": [
		5174,
		174
	],
	"./logos/colivri-logo_imagotipo-black.svg": [
		2269,
		269
	],
	"./logos/colivri-logo_imagotipo-white-bg.svg": [
		3061,
		61
	],
	"./metaverso.webp": [
		5594
	],
	"./people/abel.png": [
		8716,
		716
	],
	"./people/juan.png": [
		9060,
		60
	],
	"./people/juanjo.jpg": [
		5233,
		233
	],
	"./people/julian.png": [
		5669,
		669
	],
	"./talleres.jpg": [
		984
	],
	"./talleres/t1.webp": [
		5908,
		908
	],
	"./talleres/t2.webp": [
		369,
		369
	],
	"./talleres/t3.webp": [
		5142,
		142
	],
	"./talleres/t4.webp": [
		2539,
		539
	],
	"./talleres/t5.webp": [
		7192,
		192
	],
	"./talleres/t6.webp": [
		2469,
		469
	],
	"./talleres/t7.webp": [
		8442,
		442
	],
	"./talleres_hero.jpg": [
		6585,
		585
	],
	"./team.jpg": [
		8847,
		847
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7584;
module.exports = webpackAsyncContext;